import { Component } from '@verndale/core';
import _debounce from 'lodash/debounce';

import { setQueryStringValue, getQueryStringValue } from '../utils/url';
import { switchItemsAnimation } from '../utils/transitions';
import { triggerClickEvent, triggerCustomEvent } from '../utils/events';

class Tabs extends Component {
  setupDefaults() {
    this.dom = {
      $tabsContainer: this.el._$('.tabs'),
      $filterTabs: this.el._$$('.tabs__tab'),
      $dropdown: this.el._$('.dropdown'),
      $dropdownListBox: this.el._$('.dropdown__listbox'),
      $tabsContent: this.el._$$('.tab-content')
    };

    this.el.levelQueryParam = this.el.dataset.levelQueryParam;
    this.init();
    this.checkOverflow();
  }

  addListeners() {
    const { $dropdownListBox, $filterTabs } = this.dom;

    $filterTabs._on('click', ::this.selectFilterFromTab);
    $dropdownListBox?._on('valueChange', ::this.selectFilterFromDropdown);
    window.addEventListener(
      'resize',
      _debounce(this.handleResize.bind(this), 50)
    );
  }

  init() {
    const level = getQueryStringValue(this.el.levelQueryParam);
    if (level) return this.getQueryParameters(level);

    this.selectDefaultDropdownOption();
  }

  checkOverflow() {
    if (this.dom.$dropdown) {
      const element = this.dom.$tabsContainer;

      if (
        element.scrollWidth > element.clientWidth ||
        element.clientWidth === 0
      ) {
        element.classList.add('tabs--overflow');
        this.dom.$dropdown.style.display = 'block';
      } else {
        element.classList.remove('tabs--overflow');
        this.dom.$dropdown.style.removeProperty('display');
      }
    }
  }

  handleResize() {
    this.checkOverflow();
  }

  selectFilterFromTab(e) {
    const { $dropdownListBox } = this.dom;
    const value = e.target.dataset.value;

    if ($dropdownListBox) {
      this.triggerDropdownChange(value);
    } else {
      this.selectFilterFromTabs(e);
    }
  }

  selectFilterFromTabs(e) {
    const { $filterTabs } = this.dom;
    const { value } = e.target.dataset;
    const $selectedTab = $filterTabs.find(
      ($tab) => $tab.dataset.value === value
    );

    this.highlightSelectedTab($selectedTab);
    this.activeTab(e.target.getAttribute('aria-controls'));
    if (this.el.levelQueryParam) {
      this.setQueryParameters(value);
    }
  }

  selectFilterFromDropdown(e) {
    const { $filterTabs } = this.dom;
    const value = e?.detail.value;
    const $selectedTab = $filterTabs.find(
      ($tab) => $tab.dataset.value === value
    );

    if ($selectedTab) {
      this.highlightSelectedTab($selectedTab);
      this.activeTab($selectedTab.getAttribute('aria-controls'));
      triggerCustomEvent($selectedTab, 'tabSelected');
    }

    if (this.el.levelQueryParam) {
      this.setQueryParameters(value);
    }
  }

  highlightSelectedTab($selectedTab) {
    const { $filterTabs } = this.dom;

    $filterTabs.forEach(($tab) => $tab.setAttribute('aria-selected', 'false'));

    if ($selectedTab) {
      $selectedTab.setAttribute('aria-selected', 'true');
    }
  }

  getQueryParameters(level) {
    this.selectFilterFromDropdown({ detail: { value: level } });
    this.triggerDropdownChange(level);
  }

  setQueryParameters(level) {
    setQueryStringValue(this.el.levelQueryParam, level);
  }

  triggerDropdownChange(value) {
    const { $dropdownListBox } = this.dom;
    if (!$dropdownListBox) return;

    triggerClickEvent(
      $dropdownListBox._$(`.dropdown__option[data-value="${value}"]`)
    );
  }

  activeTab(activeId) {
    const { $tabsContent } = this.dom;

    return switchItemsAnimation(
      $tabsContent.find(($tab) => $tab.id === activeId),
      $tabsContent
    );
  }

  selectDefaultDropdownOption() {
    const { $filterTabs } = this.dom;
    const $selectedTab = $filterTabs.find(
      ($tab) => $tab.getAttribute('aria-selected') === 'true'
    );
    if (!$selectedTab) return;

    this.triggerDropdownChange($selectedTab.dataset.value);
  }
}

export default Tabs;
